export default {
    사이트명: "다미방",
    사업명: "다미방",
    신동원: "신동원",
    "395-09-02501": "395-09-02501",
    "010-2345-8499": "010-2345-8499",
    addressTxt: "충청북도 괴산군 연풍면 향교로홍문길 7 101호",
    emailTxt: "kevin1327@naver.com",

    en: {
        Login: "Login",
        Logout: "Logout",
        Join: "Join",
        Mypage: "Mypage",
    },

    // header, 회원
    "모바일 메뉴 열기": "모바일 메뉴 열기",
    "모바일 메뉴 닫기": "모바일 메뉴 닫기",
    "홈으로 이동": "홈으로 이동",
    로그인: "로그인",
    로그아웃: "로그아웃",
    회원가입: "회원가입",
    마이페이지: "마이페이지",
    회원정보수정: "회원정보수정",
    "자주 묻는 질문": "자주 묻는 질문",
    공지사항: "공지사항",
    "1:1 문의": "1:1 문의",
    개인정보: "개인정보",
    개인정보처리방침: "개인정보처리방침",
    이용약관: "이용약관",
    "관리자 문의": "관리자 문의",
    "아이디 저장": "아이디 저장",
    "아이디/비밀번호 찾기": "아이디/비밀번호 찾기",
    "아이디 찾기": "아이디 찾기",
    "비밀번호 찾기": "비밀번호 찾기",
    "회원가입이 완료되었습니다": "회원가입이 완료되었습니다.",

    // footer
    대표이사: "대표이사",
    사업자등록번호: "사업자등록번호",
    문의번호: "문의번호",
    주소: "주소",

    // 버튼
    찾기: "찾기",
    검색: "검색",
    취소: "취소",
    등록: "등록",
    다음: "다음",
    글쓰기: "글쓰기",
    저장하기: "저장하기",
    수정하기: "수정하기",
    삭제하기: "삭제하기",
    "자세히 보기": "자세히 보기",
    내용보기: "내용보기",
    가입하기: "가입하기",
    문의하기: "문의하기",
    인증요청: "인증요청",
    본인인증: "본인인증",
    인증완료: "인증완료",
    "확인하러 가기": "확인하러 가기",
    "로그인하러 가기": "로그인하러 가기",

    // form
    아이디: "아이디",
    비밀번호: "비밀번호",
    "비밀번호 확인": "비밀번호 확인",
    이름: "이름",
    이메일: "이메일",
    연락처: "연락처",
    내용: "내용",
    "문의 내용": "문의 내용",
    사업자등록증: "사업자등록증",
    재직증명서: "재직증명서",
    국가선택: "국가선택",
    수신동의: "{txt} 수신동의",
    국문: "국문",
    영문: "영문",
    한자: "한자",
    agree: {
        필수: "필수",
        선택: "선택",
    },

    // placeholder, label
    선택: "선택",
    "을 입력하세요": "@.lower:{txt}을 입력하세요.",
    "를 입력하세요": "@.lower:{txt}를 입력하세요.",
    "검색어를 입력하세요": "검색어를 입력하세요.",
    "전화번호를 입력하세요": "전화번호를 입력하세요.",
    "인증번호를 입력하세요": "인증번호를 입력하세요.",
    "이름을 입력하세요": "이름을 입력하세요.",
    "이름 또는 기관명을 입력하세요": "이름 또는 기관명을 입력하세요.",
    "이메일을 입력하세요": "이메일을 입력하세요.",
    "내용을 입력하세요": "내용을 입력하세요.",
    "문의 내용을 입력하세요": "문의 내용을 입력하세요.",
    "파일을 첨부하세요": "파일을 첨부하세요.",
    "‘-’를 제외하고 입력하세요": "‘-’를 제외하고 입력하세요.",
    "필수 입력 항목입니다": "필수 입력 항목입니다.",
    "인증절차를 진행해주세요": "인증절차를 진행해주세요.",
    "아이디 찾기를 위해 등록된 핸드폰 번호를 입력해주세요": "아이디 찾기를 위해 등록된 핸드폰 번호를 입력해주세요.",
    "영문, 숫자 포함 5자 이상 입력해주세요": "영문, 숫자 포함 5자 이상 입력해주세요.",
    "영문, 숫자 5자 이상 작성해주세요": "영문, 숫자 5자 이상 작성해주세요.",
    "영문, 숫자, 특수기호 포함 8자 이상 입력해주세요": "영문, 숫자, 특수기호 포함 8자 이상 입력해주세요.",
    "비밀번호를 입력하세요": "비밀번호를 입력하세요.",
    "동일한 비밀번호를 재입력하세요": "동일한 비밀번호를 재입력하세요.",
    "비밀번호 찾기를 위해 등록된 핸드폰 번호를 입력해주세요": "비밀번호 찾기를 위해 등록된 핸드폰 번호를 입력해주세요.",
    "자 이내": "{num}자 이내",
    이하: "{num} 이하",
    "약관에 전체 동의합니다": "약관에 전체 동의합니다.",

    // alert
    "로그아웃 하시겠습니까?": "로그아웃 하시겠습니까?",
    "로그아웃 되었습니다": "로그아웃 되었습니다.",

    // 게시판
    번호: "번호",
    제목: "제목",
    작성자: "작성자",
    작성일: "작성일",
    조회수: "조회수",
    상태: "상태",
    답변대기: "답변대기",
    답변완료: "답변완료",

    // 결제
    신용카드: "신용카드",
    무통장입금: "무통장입금",
    카카오페이: "카카오페이",

    // page text
    "오시는 길": "오시는 길",
    제로장: "제로장",
    케이장: "케이장",
    "떡볶이의 꿈": "떡볶이의 꿈",
    개요: "개요",
    비전: "비전",
    zeroZang: {
        tag: "#무설탕 #저칼로리 #저염고추장",
        txt: "다이어트 혹은 건강관리가 중요하신<br>분들을 위하여 특별히 개발된 고추장",
        txt2: "다이어트 혹은 건강관리가 중요하신 분들을 위하여 특별히 개발된 고추장",
    },
    kZang: {
        tag: "#전통고추장",
        txt: "전통 고추장 원료를 사용하여 고유의 풍미를<br>살리고 염도를 줄인 신개념 고추장",
        txt2: "한국의 전통 고추장 원료를사용하여 고유의 풍미를 살리고 칼로리와 염도를 줄인 <br class='d-none d-lg-block'>신개념 고추장",
    },
    DOT: {
        tag: "#프리미엄 소스",
        txt: "최고급 원료를 아낌없이 사용하여 떡볶이 소스로서 <br>최상의 맛을 구현한 저칼로리 프리미엄 소스",
        txt2: "최고급 원료를 아낌없이 사용하여 떡볶이 소스로서 최상의 맛을 구현한 저칼로리 <br class='d-none d-lg-block'>프리미엄 소스(찌게, 볶음용 소스)",
    },

    // page btn

    // page placeholder, label

    // gnbs
    회사소개: "회사소개",
    고추장이야기: "고추장이야기",
    "고추장 이야기": "고추장 이야기",
    제품소개: "제품소개",

    // 회원가입
    국내회원: "국내회원",
    개인회원: "개인회원",
    단체회원: "단체회원",
    "국내 개인회원": "국내 개인회원",
    "국내 단체회원": "국내 단체회원",
    "해외거주 회원": "해외거주 회원",
    "국내 개인 회원가입": "국내 개인 회원가입",
    "국내 단체 회원가입": "국내 단체 회원가입",
    "국내 거주자 회원가입": "국내 거주자 회원가입",
    "해외거주자 회원가입": "해외거주자 회원가입",

    // 마이페이지

    // Page
    visual1: {
        tit: "건강한 식탁을 만드는",
        txt: "세계인 모두에게 사랑받고 모든 가정의 식탁에 우리의 식품이 놓이는 그날까지 <br class='d-none d-md-block' />100% 국산 원료만을 사용하여 여러분에게 신뢰를 드리겠습니다.",
    },
    main: {
        section1: "우리의 제품 이야기",
        section2: "건강한 식문화를 만드는 사람들의 이야기",
        story1: "<span class='font-weight-extrabold'>건강한 식문화</span>를 만드는 <br class='d-none d-sm-block' />기업입니다.",
        story2: "<span class='font-weight-extrabold'>식품개발</span>과 <span class='font-weight-extrabold'>기술력확보</span>에 <br class='d-none d-sm-block' />노력하고 있습니다.",
        story3: "K-food를 <span class='font-weight-extrabold'>세계화</span>로 이끄는 <br class='d-none d-sm-block' />글로벌 기업으로 발돋움 합니다.",
    },
    company: {
        tit: "‘한국을 대표하며 세계인 모두가 사랑하는 장을 개발해야 한다’<span class='font-weight-regular'>는 신념으로 <br class='d-none d-lg-block' />수년간 끊임없이 노력해 왔습니다.</span>",
        txt: "우리에겐 5백년간 한식에, 고유한 우리의 맛을 내기 위하여 우리의 조상들이 사용해 왔던 역사와 전통의 장(醬, Sauce)이 있습니다. 이제 한류 붐과 함께 한식에만 사용해 왔던 우리의 장을 전 세계인이 더불어 즐길 수 있는 글로벌시대가 되었습니다. 다미방은 전통장을 재해석하여 세계 어느 요리에도 어울리는 장을 지속적으로 연구하고자 합니다.",
    },
    vision: {
        num01: "철저한 품질관리 시스템",
        num01Txt: "최고 품질의 국산 원료만을 엄선하여 <br class='d-none d-lg-block'/>철저한 품질 관리 시스템을 통해 고객의 건강을 생각하는 <br class='d-none d-lg-block' />신선하고 안전한 제품만을 만들겠습니다.",

        num02: "지속적인 연구 및 개발",
        num02Txt: "한식뿐만 아니라 전 세계의 다양한 요리 경험을 <br class='d-none d-lg-block' />선사하기 위하여 지속적인 연구 및 개발을 통해 혁신적이고 <br class='d-none d-lg-block' />창의적인 제품을 선보이겠습니다.",

        num03: "최상의 고객 서비스",
        num03Txt: "고객에게 항상 최상의 제품과 서비스를 제공하여 <br class='d-none d-lg-block' />신뢰와 만족을 드리기 위해 노력하겠습니다.",

        num04: "철저한 품질관리 시스템",
        num04Txt: "최고 품질의 국산 원료만을 엄선하여 <br class='d-none d-lg-block' />철저한 품질 관리 시스템을 통해 고객의 건강을 생각하는 <br class='d-none d-lg-block' />신선하고 안전한 제품만을 만들겠습니다."
    },
    story1: {
        tit: "K-Sauce 세계화",
        txt: "시대가 바뀌어 세계화 시대에 한류 붐이 활짝 피고, K-Food도 <br class='d-none d-xl-block' />세계로 진출하게 되었고, 아울러 K-Sauce도 세계의 소스가 되어야 하는 <br class='d-none d-xl-block' />시점이 되었습니다.",
    },
    story2: {
        tit: "K-Hot Sauce 개발",
        txt: "이에, 저희는 한식에 정형화되어 있는 고추장을 세계 어느 요리에도 <br class='d-none d-xl-block' />어울릴 수 있게 전통의 맛을 유지하며 그 용도를 확장한 혁신적인 <br class='d-none d-xl-block' />한국의 대표 K-Hot Sauce를 개발하게 되었습니다.",
    },
    story3: {
        tit: "500년 전통 고추장",
        txt: "우리의 전통고추장은 500년 동안 우리의 조상들이 한식에 매운맛과 <br class='d-none d-xl-block' />풍부한 향을 내기 위하여 사용해 왔던 대표 장입니다. 아직까지 해마다 <br class='d-none d-xl-block' />봄이면 새로운 장을 담그는 풍습을 이어오고 있습니다.",
    },
    story4: {
        tit: "고객의 건강을 생각한 고추장",
        txt: "저희는 염도를 낮추고, 칼로리를 혁신적으로 줄여 고객의 건강을 <br class='d-none d-xl-block' />생각하고 편리하고 위생적으로 따라 쓸 수 있는 제품을 만들어 전통장을 <br class='d-none d-xl-block' />현대화하는 데 앞장서고 있습니다. 이제 세계인 모두에게 사랑받고 모든 <br class='d-none d-xl-block' />가정의 식탁에 하나씩 놓이는 그날까지 100% 국산 원료만을 사용하여 <br class='d-none d-xl-block' />여러분에게 신뢰를 드리겠습니다.",
    },
};
